export default function checkStatus({ response, url, customMessage }) {
  /*
  Default status codes also present in MW template
  https://wiki.delawareconsulting.com/pages/viewpage.action?pageId=122061198
  400 - Front-end can't fix the problem	- BusinessException
  401 - Not authenticated	 
  403 - Not authorized for the requested action	 
  409 - Front-end must take action exception - Is not logged in App Insights
  500 - MW bug - TechnicalException
  502 - Backend problem	- eg SAP
  */

  if (customMessage) {
    return customMessage;
  }

  const { status } = response;

  if (!response) {
    return `Uncaught (no response) - Something went wrong calling server`;
  }

  if (status === 400) {
    return `Business exception - server responded with a status code ${response.status}`;
  }

  if (status === 401) {
    return `Unauthorized - server responded with a status code ${response.status}`;
  }

  if (status === 403) {
    return `Forbidden - server responded with a status code ${response.status}`;
  }

  if (status === 404) {
    return `Not found - the requested resource was not found. erver responded with a status code ${response.status}`;
  }

  if (status > 404 && status < 500 && status !== 409) {
    return `Uncaught - server responded with a status code ${response.status}`;
  }

  if (status === 500) {
    return `Server Error - server responded with a status code ${response.status}`;
  }

  if (status === 502) {
    return `Backend Error - server responded with a status code ${response.status}`;
  }

  if (status > 500) {
    return `Uncaught - server responded with a status code ${response.status}`;
  }
  return null;
}
